import state from './chatBotState.js'
import mutations from './chatBotMutations.js'
import actions from './chatBotActions.js'
// import getters from './moduleChatGetters.js'

export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    // getters: getters
}
